import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Experiences = lazy(() => import("@/pages/admin/galaxy/experiences/Experiences/Experiences"));
const AddExperience = lazy(() => import("@/pages/admin/galaxy/experiences/AddExperience"));
const EditExperience = lazy(() => import("@/pages/admin/galaxy/experiences/EditExperience/EditExperience"));

const Prospects = lazy(() => import("@/pages/admin/galaxy/prospects/Prospects/Prospects"));
const AddProspect = lazy(() => import("@/pages/admin/galaxy/prospects/AddProspect"));
const EditProspect = lazy(() => import("@/pages/admin/galaxy/prospects/EditProspect/EditProspect"));

const Posts = lazy(() => import("@/pages/admin/galaxy/posts/Posts/Posts"));
const AddPost = lazy(() => import("@/pages/admin/galaxy/posts/AddPost"));
const EditPost = lazy(() => import("@/pages/admin/galaxy/posts/EditPost/EditPost"));

const Blogs = lazy(() => import("@/pages/admin/galaxy/blogs/Blogs/Blogs"));
const AddBlog = lazy(() => import("@/pages/admin/galaxy/blogs/AddBlog"));
const EditBlog = lazy(() => import("@/pages/admin/galaxy/blogs/EditBlog/EditBlog"));

const Offers = lazy(() => import("@/pages/admin/galaxy/offers/Offers/Offers"));
const AddOffer = lazy(() => import("@/pages/admin/galaxy/offers/AddOffer"));
const EditOffer = lazy(() => import("@/pages/admin/galaxy/offers/EditOffer/EditOffer"));

const Testimonials = lazy(() => import("@/pages/admin/galaxy/testimonials/Testimonials/Testimonials"));
const AddTestimonial = lazy(() => import("@/pages/admin/galaxy/testimonials/AddTestimonial"));
const EditTestimonial = lazy(() => import("@/pages/admin/galaxy/testimonials/EditTestimonial/EditTestimonial"));

const Suppliers = lazy(() => import("@/pages/admin/galaxy/suppliers/Suppliers/Suppliers"));
const AddSupplier = lazy(() => import("@/pages/admin/galaxy/suppliers/AddSupplier/AddSupplier"));
const EditSupplier = lazy(() => import("@/pages/admin/galaxy/suppliers/EditSupplier/EditSupplier"));

const Tours = lazy(() => import("@/pages/admin/galaxy/tours/Tours"));

const Websites = lazy(() => import("@/pages/admin/galaxy/websites/Websites/Websites"));
const AddWebsite = lazy(() => import("@/pages/admin/galaxy/websites/AddWebsite/AddWebsite"));
const EditWebsite = lazy(() => import("@/pages/admin/galaxy/websites/EditWebsite/EditWebsite"));

const Analytics = lazy(() => import("@/pages/admin/galaxy/analytic/Analytics"));

const Settings = lazy(() => import("@/pages/admin/galaxy/settings/Settings"));

const ItcBookings = lazy(() => import("@/pages/admin/galaxy/itc-bookings/ItcBookings"));

const Error404 = lazy(() => import("@/pages/Error404"));

const galaxyRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  { path: "itc-bookings", children: [{ index: true, element: <ItcBookings /> }] },
  {
    path: "experiences",
    children: [
      {
        index: true,
        element: <Experiences />,
      },
      {
        path: "new",
        element: <AddExperience />,
      },
      {
        path: ":id",
        element: <EditExperience />,
      },
    ],
  },
  {
    path: "prospects",
    children: [
      {
        index: true,
        element: <Prospects />,
      },
      {
        path: "new",
        element: <AddProspect />,
      },
      {
        path: ":id",
        element: <EditProspect />,
      },
    ],
  },
  {
    path: "posts",
    children: [
      {
        index: true,
        element: <Posts />,
      },
      {
        path: "new",
        element: <AddPost />,
      },
      {
        path: ":id",
        element: <EditPost />,
      },
    ],
  },
  {
    path: "blogs",
    children: [
      {
        index: true,
        element: <Blogs />,
      },
      {
        path: "new",
        element: <AddBlog />,
      },
      {
        path: ":id",
        element: <EditBlog />,
      },
    ],
  },
  {
    path: "offers",
    children: [
      {
        index: true,
        element: <Offers />,
      },
      {
        path: "new",
        element: <AddOffer />,
      },
      {
        path: ":id",
        element: <EditOffer />,
      },
    ],
  },
  {
    path: "testimonials",
    children: [
      {
        index: true,
        element: <Testimonials />,
      },
      {
        path: "new",
        element: <AddTestimonial />,
      },
      {
        path: ":id",
        element: <EditTestimonial />,
      },
    ],
  },
  {
    path: "suppliers",
    children: [
      {
        index: true,
        element: <Suppliers />,
      },
      {
        path: "new",
        element: <AddSupplier />,
      },
      {
        path: ":id",
        element: <EditSupplier />,
      },
    ],
  },
  {
    path: "tours",
    children: [
      {
        index: true,
        element: <Tours />,
      },
    ],
  },
  {
    path: "websites",
    children: [
      {
        index: true,
        element: <Websites />,
      },
      {
        path: "new",
        element: <AddWebsite />,
      },
      {
        path: ":id",
        element: <EditWebsite />,
      },
    ],
  },
  {
    path: "analytics",
    children: [
      {
        index: true,
        element: <Analytics />,
      },
    ],
  },
  {
    path: "settings",
    children: [
      {
        index: true,
        element: <Settings />,
      },
    ],
  },
];

export default galaxyRoutes;
